import { render, staticRenderFns } from "./ListCustomFieldsToggle.vue?vue&type=template&id=73a4b070&"
import script from "./ListCustomFieldsToggle.vue?vue&type=script&lang=ts&"
export * from "./ListCustomFieldsToggle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QToggle} from 'quasar'
component.options.components = Object.assign({QToggle}, component.options.components || {})
